import DatabaseResetPasswordPage from "./database-reset-password.page";
import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import Logo from "../../../components/common/logo/Logo";
import {
  Button,
  Container,
  Group,
  PasswordInput,
  Space,
  Text,
  Box,
  TextInput,
  Title,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import applicationComander from "../../../store/commanders/application.comander";
import navigationService from "../../../services/navigation/navigation.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { URL_PATHS } from "../../../consts/url.paths.consts";
import { validateEmail } from "../../../helpers/form.validators";
import { faLongArrowAltLeft, faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";
const LegacyResetPasswordPage = (props) => {
  const { t } = useTranslation();
  const onSubmit = (data) => {
    applicationComander.cmd_forgot_password_submit(
      data.userName,
      data.resetCode,
      data.confirmPassword
    );
  };

  // Get userName from navigation state (passed from forgot password flow)
  const location = useLocation();
  const userName = (location.state as any)?.userName || "";

  const form = useForm({
    initialValues: {
      userName: userName,
      password: "",
      confirmPassword: "",
      resetCode: "",
    },

    validate: {
      password: (value) => process.env.REACT_APP_AUTH_MODE !== "cognito" && (value.length < 15 || value.length > 128)
        ? "Use a password of 15–128 characters." : null,
      userName: validateEmail,
      confirmPassword: (value, values) =>
        value !== values.password ? t("auth.passwordMismatch") : null,
    },
  });
  return (
    <div>
      <div className="auth-container-box">
        <Box className="auth-single-form">
          <FontAwesomeIcon
            icon={faCircleUser as Icon}
            size={"5x"}
            className="auth-icon"
          />
          <Text className="auth-title" style={{fontSize: '2rem'}}>{t("auth.reset.title")}</Text>
          <Text className="auth-description">
            {t("auth.reset.description")}
          </Text>
          <form
            onSubmit={form.onSubmit((values) => onSubmit(values))}
            className="u-w-100"
          >
            <TextInput
              mt="sm"
              required
              type="email"
              autoComplete="email"
              label={t("auth.email")}
              placeholder={t("auth.emailPlaceholder")}
              {...form.getInputProps("userName")}
            />
            <PasswordInput
              mt="sm"
              required
              autoComplete="new-password"
              label={t("auth.newPassword")}
              placeholder={t("auth.newPasswordPlaceholder")}
              {...form.getInputProps("password")}
            />
            <PasswordInput
              mt="sm"
              required
              autoComplete="new-password"
              label={t("auth.confirmPassword")}
              placeholder={t("auth.confirmPasswordPlaceholder")}
              {...form.getInputProps("confirmPassword")}
            />
            <TextInput
              mt="sm"
              required
              autoComplete="one-time-code"
              label={t("auth.reset.code")}
              placeholder={t("auth.reset.codePlaceholder")}
              {...form.getInputProps("resetCode")}
            />
            <Space h="md" />
            <Group mt="lg" mb="sm">
              <Button size="lg" type="submit" className="u-w-100 auth-submit-button">
                {t("auth.reset.submit")}
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="u-w-100 mobile-auth-button"
                onClick={() => navigationService.navigate(URL_PATHS.LOGIN)}
              >
                {t("auth.backToLogin")}
              </Button>
            </Group>
            <Space h={"sm"}></Space>
            <Text
              component="button"
              type="button"
              size="sm"
              align="left"
              className="auth-link"
              onClick={() => navigationService.navigate(URL_PATHS.LOGIN)}
            >
              <FontAwesomeIcon icon={faLongArrowAltLeft as Icon} />
              <span className="u-ml-sm">{t("auth.backToLogin")}</span>
            </Text>
            <Button type="button" variant="subtle" mt="sm"
          onClick={() => applicationComander.cmd_forgot_password(form.values.userName)}>
          Resend verification code
        </Button>
      </form>
        </Box>
      </div>
    </div>
  );
};

export default function ResetPasswordPage(props) {
  const location = useLocation();

  const state = location.state as any;
  if (process.env.REACT_APP_AUTH_MODE === "cognito") return <LegacyResetPasswordPage {...props} />;
  return <DatabaseResetPasswordPage initialEmail={state?.userName || state?.email || ""} codeSent={state?.codeSent === true}
    migrationRequired={state?.migrationRequired === true} onLogin={email => navigationService.replace(URL_PATHS.LOGIN, { email })} />;
}
